import { DataLayerEventName, toRadioEvent } from '@news-mono/web-common'
import React, { FC, useContext } from 'react'
import { LivePlayerButtonOnly } from '../TheWestLivePlayer/TheWestLivePlayerSkin/TheWestLivePlayerSkin'
import { TheWestLiveContext, useOnAirState } from '../TheWestLiveProvider'
import { TheWestLiveWaves } from '../TheWestLiveWaves/TheWestLiveWaves'
import {
    StyledWestLiveInArticleBannerContainer,
    StyledWestLiveInArticleBannerLogoContainer,
    StyledWestLiveInArticleBannerText,
    StyledWestLiveInArticleLogo,
    StyledWestLiveInArticlePlayer,
} from './TheWestLiveInArticleBanner.styled'

export const TheWestLiveInArticleBanner: FC = () => {
    const { onAir, broadcast } = useOnAirState()
    const { playerState, setPlayerState, onEvent } =
        useContext(TheWestLiveContext)

    function handleControlClick() {
        setPlayerState({
            ...playerState,
            state: playerState.state === 'stopped' ? 'loading' : 'stopped',
        })

        onEvent(
            toRadioEvent(
                playerState.state === 'stopped'
                    ? DataLayerEventName.radioPlay
                    : DataLayerEventName.radioStop,
                broadcast,
                'card',
            ),
        )
    }

    if (!onAir) {
        return null
    }

    return (
        <StyledWestLiveInArticleBannerContainer>
            <StyledWestLiveInArticleBannerLogoContainer>
                <StyledWestLiveInArticleLogo />
                <StyledWestLiveInArticleBannerText>
                    We are live. Tune in.
                </StyledWestLiveInArticleBannerText>
            </StyledWestLiveInArticleBannerLogoContainer>
            <StyledWestLiveInArticlePlayer
                PlayerSkin={(props) => (
                    <LivePlayerButtonOnly
                        {...props}
                        onControlClick={handleControlClick}
                    />
                )}
            />
            <TheWestLiveWaves />
        </StyledWestLiveInArticleBannerContainer>
    )
}
TheWestLiveInArticleBanner.displayName = 'TheWestLiveInArticleBanner'

export default TheWestLiveInArticleBanner
